import { combineReducers } from 'redux';
import address from './address';
import config from './config';
import errors from './error';
import global from './global';
import newsletter from './newsletter';
import order from './order';
import payments from './payments';
import shipping from './shipping';
import terms from './terms';
import tracking from './tracking';
import transaction from './transaction';

const reducer = combineReducers({
    global,
    config,
    order,
    address,
    payments,
    shipping,
    errors,
    newsletter,
    tracking,
    terms,
    transaction,
});

export default reducer;
